import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@headerhawk/ui";
import { useSiteScope } from "@/lib/hooks/use-site-scope";

const ALL_SITES = "all";

/**
 * The header's site scope (ADR 013, principle 2): all sites, or one. Every
 * section reads it, and it stays in the URL, so a link carries the scope it
 * was chosen with.
 *
 * A tenant with one site is shown that site rather than a choice of one.
 */
export function SiteScopeSelect() {
  const { siteId, sites, setSiteId } = useSiteScope();

  if (sites.length === 0) return null;

  if (sites.length === 1) {
    const only = sites[0]!;
    return (
      <div
        className="flex min-w-0 items-center gap-2 text-sm text-muted-foreground"
        data-testid="site-scope-single"
      >
        <Globe className="h-4 w-4" aria-hidden />
        <span className="truncate">{only.name}</span>
      </div>
    );
  }

  return (
    <Select
      value={siteId ?? ALL_SITES}
      onValueChange={(value) =>
        setSiteId(value === ALL_SITES ? undefined : value)
      }
    >
      <SelectTrigger
        className="h-9 w-[150px] sm:w-[200px]"
        aria-label="Site"
        data-testid="site-scope"
      >
        <span className="flex min-w-0 items-center gap-2">
          <Globe className="h-4 w-4 shrink-0 opacity-70" aria-hidden />
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_SITES}>All sites</SelectItem>
        {sites.map((site) => (
          <SelectItem key={site.id} value={site.id}>
            {site.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
